/**
 * Topical internal-links block, injected once in MarketingShell after the
 * page body. Renders the current page's cluster siblings (see
 * content/relatedLinks.ts). Returns null for pages not in any cluster, so
 * it's safe to mount on every marketing route.
 */
import { getRelated } from '../content/relatedLinks';
import { type MarketingLocale } from '../i18n/marketingLocales';

export function RelatedLinks({
  hreflangPath,
  currentLocale = 'en',
}: {
  hreflangPath?: string;
  currentLocale?: MarketingLocale;
}) {
  const data = getRelated(hreflangPath, currentLocale);
  if (!data) return null;

  return (
    <section
      style={{
        borderTop: '1px solid var(--ink-0)',
        background: 'var(--paper-1)',
        padding: '48px 24px',
      }}
    >
      <div style={{ maxWidth: 1080, margin: '0 auto' }}>
        <h2 className="serif" style={{ fontSize: 22, margin: '0 0 18px' }}>
          {data.heading}
        </h2>
        <div style={{ display: 'flex', flexWrap: 'wrap', gap: 10 }}>
          {data.links.map((l) => (
            <a
              key={l.href}
              href={l.href}
              style={{
                display: 'inline-block',
                padding: '8px 14px',
                border: '1px solid var(--ink-0)',
                borderRadius: 6,
                color: 'var(--ink-1)',
                textDecoration: 'none',
                fontSize: 14,
              }}
            >
              {l.label} →
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}
